import React, { useContext, useEffect, Fragment, useState } from 'react';
import { adminSocketURL } from '../../config';
import io from 'socket.io-client';
import MainContext from '../../store/MainContext';
import IncomingCall from './IncomingCall';
import { useMainStore } from 'useStores/useMainStore';

var socketio;

const AdminSocket = ({ children }) => {
  const { state, dispatch, showMessage } = useContext(MainContext);
  const [voipData, setVoipData] = useState([]);
  const refreshToken = localStorage.getItem('@footab/admin/refreshToken');
  // FCM temporarily disabled
  // const token = useMainStore((state) => state.firebaseToken);

  const handleCloseIncomingModal = (callUID) => {
    setVoipData((prev) => [...prev.filter((v) => v.callUID !== callUID)]);
  };
  const updateVoipData = (newData) => {
    if (newData.callType === 'disconnect') {
      setVoipData((prev) => [
        ...prev.filter((v) => v.callUID !== newData.callUID),
      ]);
    } else {
      setVoipData((prev) => [...prev, newData]);
    }
  };

  useEffect(() => {
    // Listeners:
    socketio = io(adminSocketURL, {
      transports: ['websocket'],
      reconnection: true,
      query: { refreshToken },
    });
    socketio.on('connect', () => {
      socketio.emit('updateNotifications');
      dispatch({ type: 'PROPS', action: 'CONNECT' });
    });
    socketio.on('error', (error) => {
      console.error('Socket Error:', JSON.stringify(error, null, 2));
    });

    // FCM temporarily disabled
    // token?.length > 10 &&
    //   socketio.on('Notifications', ({ notifications }) => {
    //     dispatch({
    //       type: 'NOTIFICATIONS',
    //       action: 'LOAD_NOTIFICATIONS',
    //       payload: notifications,
    //     });
    //   });
    // token?.length > 10 &&
    //   socketio.on('youHaveNewNotification', () => {
    //     alert('شما نوتیفیکیشن جدید دارید!');
    //     socketio.emit('updateNotifications');
    //   });

    socketio.on('updateVoipData', (voipData) => {
      updateVoipData(voipData);
    });
    socketio.on('disconnect', () => {
      dispatch({ type: 'PROPS', action: 'DISCONNECT' });
    });

    return () => {
      socketio.removeAllListeners();
      socketio.disconnect();
    };
  }, []);

  return (
    <Fragment>
      {children}
      <IncomingCall onClose={handleCloseIncomingModal} voipData={voipData} />
    </Fragment>
  );
};

export default React.memo(AdminSocket);
export { socketio };
